import { error } from "toastr"
import {
  GET_RCA,
  GET_RCA_FAIL,
  GET_RCA_SUCCESS,
  GET_RCA_BY_ID,
  GET_RCA_BY_ID_FAIL,
  GET_RCA_BY_ID_SUCCESS,
  POST_RCA,
  POST_RCA_FAIL,
  POST_RCA_SUCCESS,
  POST_FULL_RCA,
  POST_FULL_RCA_FAIL,
  POST_FULL_RCA_SUCCESS,
  UPDATE_RCA_IMPACT,
  UPDATE_RCA_IMPACT_FAIL,
  UPDATE_RCA_IMPACT_SUCCESS,
  UPDATE_RCA_TIMELINE,
  UPDATE_RCA_TIMELINE_FAIL,
  UPDATE_RCA_TIMELINE_SUCCESS,
  UPDATE_RCA_QUESTIONS,
  UPDATE_RCA_QUESTIONS_FAIL,
  UPDATE_RCA_QUESTIONS_SUCCESS,
  UPDATE_RCA_ACTIONS,
  UPDATE_RCA_ACTIONS_FAIL,
  UPDATE_RCA_ACTIONS_SUCCESS,
  UPDATE_RCA_RELATED_ALERTS,
  UPDATE_RCA_RELATED_ALERTS_FAIL,
  UPDATE_RCA_RELATED_ALERTS_SUCCESS,
  UPDATE_RCA_RELATED_RCAS,
  UPDATE_RCA_RELATED_RCAS_FAIL,
  UPDATE_RCA_RELATED_RCAS_SUCCESS,
  UPDATE_RCA_IMPACTED_APPLICATIONS,
  UPDATE_RCA_IMPACTED_APPLICATIONS_FAIL,
  UPDATE_RCA_IMPACTED_APPLICATIONS_SUCCESS,
  GET_ACTION_ITEM_BY_ID,
  GET_ACTION_ITEM_BY_ID_FAIL,
  GET_ACTION_ITEM_BY_ID_SUCCESS,
  DELETE_RCA_BY_ID_FAIL,
  DELETE_RCA_BY_ID,
  DELETE_RCA_BY_ID_SUCCESS,
  UPDATE_RCA_INCIDENT_DETAILS,
  UPDATE_RCA_INCIDENT_DETAILS_FAIL,
  UPDATE_RCA_INCIDENT_DETAILS_SUCCESS,
  UPDATE_RCA_HEADER_DETAILS,
  UPDATE_RCA_HEADER_DETAILS_FAIL,
  UPDATE_RCA_HEADER_DETAILS_SUCCESS,
  UPDATE_ACTION_STATUS,
  UPDATE_ACTION_STATUS_FAIL,
  UPDATE_ACTION_STATUS_SUCCESS,
  CLEAR_RCA_DATA
} from "./actionTypes"

export const getRca = page_filters => {
    return {
  type: GET_RCA,
  payload: page_filters
}}

export const getRcaFail = error => ({
  type: GET_RCA_FAIL,
  payload: error
})

export const getRcaSuccess = rcas => ({
  type: GET_RCA_SUCCESS,
  payload: rcas
})

export const getRcaById = (id) => ({
  type: GET_RCA_BY_ID,
  payload: id
})

export const getRcaByIdFail = error => ({
  type: GET_RCA_BY_ID_FAIL,
  payload: error
})

export const getRcaByIdSuccess = rca => ({
  type: GET_RCA_BY_ID_SUCCESS,
  payload: rca
})

export const deleteRcaById = (id) => ({
    type: DELETE_RCA_BY_ID,
    payload: id
})

export const deleteRcaByIdFail = error => ({
    type: DELETE_RCA_BY_ID_FAIL,
    payload: error
})

export const deleteRcaByIdSuccess = (message) => ({
    type: DELETE_RCA_BY_ID_SUCCESS,
    payload: message
})
export const getActionItemById = (id) => ({
  type: GET_ACTION_ITEM_BY_ID,
  payload: id
})

export const getActionItemByIdFail = error => ({
  type: GET_ACTION_ITEM_BY_ID_FAIL,
  payload: error
})

export const getActionItemByIdSuccess = action_item => ({
  type: GET_ACTION_ITEM_BY_ID_SUCCESS,
  payload: action_item
})

// export const postRca = (data) => ({
//   type: POST_RCA,
//   payload: data
// })
//
// export const postRcaFail = error => ({
//   type: POST_RCA_FAIL,
//   payload: error
// })
//
// export const postRcaSuccess = (message) => ({
//   type: POST_RCA_SUCCESS,
//   payload: message
// })

export const postFullRca = (data) => ({
  type: POST_FULL_RCA,
  payload: data
})

export const postFullRcaFail = error => ({
  type: POST_FULL_RCA_FAIL,
  payload: error
})

export const postFullRcaSuccess = (message) => ({
  type: POST_FULL_RCA_SUCCESS,
  payload: message
})

export const updateRcaImpact = (data) => ({
  type: UPDATE_RCA_IMPACT,
  payload: data
})

export const updateRcaImpactFail = error => ({
  type: UPDATE_RCA_IMPACT_FAIL,
  payload: error
})

export const updateRcaImpactSuccess = (message) => ({
  type: UPDATE_RCA_IMPACT_SUCCESS,
  payload: message
})

export const updateRcaTimeline = (data) => ({
  type: UPDATE_RCA_TIMELINE,
  payload: data
})

export const updateRcaTimelineFail = error => ({
  type: UPDATE_RCA_TIMELINE_FAIL,
  payload: error
})

export const updateRcaTimelineSuccess = (message) => ({
  type: UPDATE_RCA_TIMELINE_SUCCESS,
  payload: message
})

export const updateRcaQuestions = (data) => ({
  type: UPDATE_RCA_QUESTIONS,
  payload: data
})

export const updateRcaQuestionsFail = error => ({
  type: UPDATE_RCA_QUESTIONS_FAIL,
  payload: error
})

export const updateRcaQuestionsSuccess = (message) => ({
  type: UPDATE_RCA_QUESTIONS_SUCCESS,
  payload: message
})

export const updateRcaIncidentDetails = (data) => ({
  type : UPDATE_RCA_INCIDENT_DETAILS,
  payload: data
})

export const updateRcaIncidentDetailsFail = error => ({
  type : UPDATE_RCA_INCIDENT_DETAILS_FAIL,
  payload: error
})

export const updateRcaIncidentDetailsSuccess = message => ({
  type : UPDATE_RCA_INCIDENT_DETAILS_SUCCESS,
  payload: message
})

export const updateRcaHeaderDetails = (data) => ({
  type: UPDATE_RCA_HEADER_DETAILS,
  payload: data
})

export const updateRcaHeaderDetailsFail = error => ({
  type : UPDATE_RCA_HEADER_DETAILS_FAIL,
  payload: error
})

export const updateRcaHeaderDetailsSuccess  = message => ({
  type: UPDATE_RCA_HEADER_DETAILS_SUCCESS,
  payload: message
})

export const updateActionItemStatus = (data) => ({
  type: UPDATE_ACTION_STATUS,
  payload: data
})

export const updateActionItemStatusFail = error => ({
  type : UPDATE_ACTION_STATUS_FAIL,
  payload: error
})

export const updateActionItemStatusSuccess = message => ({
  type: UPDATE_ACTION_STATUS_SUCCESS,
  payload: message
})


export const updateRcaActions = (data) => ({
  type: UPDATE_RCA_ACTIONS,
  payload: data
})

export const updateRcaActionsFail = error => ({
  type: UPDATE_RCA_ACTIONS_FAIL,
  payload: data
})

export const updateRcaActionsSuccess = (message) => ({
  type: UPDATE_RCA_ACTIONS_SUCCESS,
  payload: message
})

export const updateRcaRelatedAlerts = (data) => ({
  type: UPDATE_RCA_RELATED_ALERTS,
  payload: data
})

export const updateRcaRelatedAlertsFail = error => ({
  type: UPDATE_RCA_RELATED_ALERTS_FAIL,
  payload: error
})

export const updateRcaRelatedAlertsSuccess = (message) => ({
  type: UPDATE_RCA_RELATED_ALERTS_SUCCESS,
  payload: message
})

export const updateRcaRelatedRcas = (data) => ({
  type: UPDATE_RCA_RELATED_RCAS,
  payload: data
})

export const updateRcaRelatedRcasFail = error => ({
  type: UPDATE_RCA_RELATED_RCAS_FAIL,
  payload: error
})

export const updateRcaRelatedRcasSuccess = (message) => ({
  type: UPDATE_RCA_RELATED_RCAS_SUCCESS,
  payload: message
})

export const updateRcaImpactedApplications = (data) => ({
  type: UPDATE_RCA_IMPACTED_APPLICATIONS,
  payload: data
})

export const updateRcaImpactedApplicationsFail = error => ({
  type: UPDATE_RCA_IMPACTED_APPLICATIONS_FAIL,
  payload: error
})

export const updateRcaImpactedApplicationsSuccess = (message) => ({
  type: UPDATE_RCA_IMPACTED_APPLICATIONS_SUCCESS,
  payload: message
})

export const clearRcaData = () => ({
  type: CLEAR_RCA_DATA
});